


// import { API_BASE_URL } from "../config";
// import { refreshTokenStart, refreshTokenSuccess, refreshTokenFailure } from "../store/authSlice";
// import store from "../store";
// import Cookies from "js-cookie";

// export const refreshAccessToken = async () => {
//   const refreshToken = Cookies.get("refresh_token");
  
//   if (!refreshToken) {
//     store.dispatch(refreshTokenFailure("No refresh token available"));
//     return null;
//   }

//   store.dispatch(refreshTokenStart());
  
//   try {
//     const response = await fetch(`${API_BASE_URL}/auth/token/refresh/`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       credentials: 'include',
//       body: JSON.stringify({ refresh: refreshToken }),
//     });

//     if (!response.ok) {
//       throw new Error("Token refresh failed");
//     }

//     const data = await response.json();
    
//     // Dispatch success with the full response
//     store.dispatch(refreshTokenSuccess(data));
    
//     return data.access;
//   } catch (error) {
//     store.dispatch(refreshTokenFailure(error.message));
    
//     // Clear invalid cookies on refresh failure
//     Cookies.remove("access_token");
//     Cookies.remove("refresh_token");
//     Cookies.remove("user_role");
    
//     return null;
//   }
// };

// export const authFetch = async (url, options = {}) => {
//   // ALWAYS read from cookies first
//   let token = Cookies.get('access_token') || store.getState().auth.token;
  
//   const requestOptions = {
//     ...options,
//     credentials: 'include',
//     headers: {
//       ...options.headers,
//       Authorization: token ? `Bearer ${token}` : '',
//     },
//   };

//   let response = await fetch(url, requestOptions);
  
//   // If token is expired, try to refresh it
//   if (response.status === 401) {
//     const newToken = await refreshAccessToken();
    
//     if (newToken) {
//       requestOptions.headers.Authorization = `Bearer ${newToken}`;
//       response = await fetch(url, requestOptions);
//     } else {
//       window.location.href = "/accounts";
//       return null;
//     }
//   }
  
//   return response;
// };


import { API_BASE_URL } from "../config";
import {
  refreshTokenStart,
  refreshTokenSuccess,
  refreshTokenFailure,
  roleConfirmed,
  roleRejected,
} from "../store/authSlice";
import store from "../store";
import Cookies from "js-cookie";

// Checks whether a role is actually assigned to the currently
// authenticated user, by asking the backend directly — never trust
// a role value that only lives in a client-editable cookie.
export const isRoleValid = async (token, roleToCheck) => {
  if (!token || !roleToCheck) return false;
  try {
    const response = await fetch(`${API_BASE_URL}/auth/my-roles/`, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      credentials: "include",
    });

    if (!response.ok) return false;

    const data = await response.json();
    return (data.roles || []).includes(roleToCheck);
  } catch {
    return false;
  }
};

// Convenience wrapper used at app boot to re-check whatever role is
// currently sitting in cookies/Redux against the server's roles list.
export const validateActiveRole = async () => {
  const token = Cookies.get("access_token") || store.getState().auth.token;
  const currentRole = Cookies.get("user_role") || store.getState().auth.role;

  const valid = await isRoleValid(token, currentRole);

  if (!valid) {
    store.dispatch(roleRejected("Role mismatch detected. Please log in again."));
    return false;
  }

  store.dispatch(roleConfirmed());
  return true;
};

export const refreshAccessToken = async () => {
  const refreshToken = Cookies.get("refresh_token");

  if (!refreshToken) {
    store.dispatch(refreshTokenFailure("No refresh token available"));
    return null;
  }

  store.dispatch(refreshTokenStart());

  try {
    const response = await fetch(`${API_BASE_URL}/auth/token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ refresh: refreshToken }),
    });

    if (!response.ok) {
      throw new Error("Token refresh failed");
    }

    const data = await response.json();
    store.dispatch(refreshTokenSuccess(data));
    return data.access;
  } catch (error) {
    store.dispatch(refreshTokenFailure(error.message));
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    Cookies.remove("user_role");
    return null;
  }
};

export const authFetch = async (url, options = {}) => {
  let token = Cookies.get("access_token") || store.getState().auth.token;

  const requestOptions = {
    ...options,
    credentials: "include",
    headers: {
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };

  let response = await fetch(url, requestOptions);

  if (response.status === 401) {
    const newToken = await refreshAccessToken();

    if (newToken) {
      requestOptions.headers.Authorization = `Bearer ${newToken}`;
      response = await fetch(url, requestOptions);
    } else {
      window.location.href = "/accounts";
      return null;
    }
  }

  return response;
};